/**
* Service for OAuth authorization flow.
*
* Responsibilities:
* - Fetch OAuth client info
* - Request OAuth authorization code
*/
import type {
  IAuthClient,
} from "../types";

import type { ApiClient } from "@/common/api/http/types";

interface IOAuthCodeParams {
  client_id: string;
  scope: string;
  redirect_uri: string;
  response_type: string;
  state: string;
}

interface IOAuthCodeResult {
  url: string;
}

export default class OAuthService {
  public constructor(private readonly client: ApiClient) {}

  async getAuthClient(id: string): Promise<IAuthClient> {
    return await this.client.get(`v2/auth/clients/${encodeURIComponent(id)}`);
  }

  async getOAuthCode(params: IOAuthCodeParams): Promise<IOAuthCodeResult> {
    return await this.client.post("/v2/oauth/code", params);
  }
}
